import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const authed = user && user !== false;

  return (
    <header className="sticky top-0 z-40 border-b border-[#EBEBEA] bg-white/90 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 group">
          <span className="notion-emoji-box callout-blue">🔎</span>
          <span className="font-semibold text-[#37352F] text-[15px]">Rank Notes</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-sm">
          <NavLink to="/" active={location.pathname === "/"} testId="nav-home">Home</NavLink>
          <NavLink to="/pricing" active={location.pathname === "/pricing"} testId="nav-pricing">Pricing</NavLink>
          {authed && <NavLink to="/dashboard" active={location.pathname.startsWith("/dashboard")} testId="nav-dashboard">Dashboard</NavLink>}
          {authed && <NavLink to="/history" active={location.pathname === "/history"} testId="nav-history">History</NavLink>}
          {authed && user.role === "admin" && <NavLink to="/admin" active={location.pathname === "/admin"} testId="nav-admin">Admin</NavLink>}
        </nav>

        <div className="flex items-center gap-2">
          {!authed ? (
            <>
              <Link to="/login" data-testid="header-login-link" className="text-sm text-[#37352F] hover:bg-[#F1F1EF] px-3 py-1.5 rounded-md transition-colors">Log in</Link>
              <Link to="/signup" data-testid="header-signup-link" className="bg-[#2383E2] text-white px-3 py-1.5 rounded-md text-sm font-medium hover:bg-[#1A6FCC] transition-colors">Sign up</Link>
            </>
          ) : (
            <>
              <span className="hidden sm:inline text-xs text-[#787774]" data-testid="header-user-email">{user.email}</span>
              <button
                data-testid="header-logout-btn"
                onClick={() => { logout(); navigate("/"); }}
                className="flex items-center gap-1.5 text-sm text-[#37352F] hover:bg-[#F1F1EF] px-3 py-1.5 rounded-md transition-colors"
              >
                <LogOut className="w-3.5 h-3.5" /> Logout
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

function NavLink({ to, active, testId, children }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`px-3 py-1.5 rounded-md transition-colors ${active ? "bg-[#F1F1EF] text-[#37352F] font-medium" : "text-[#787774] hover:bg-[#F7F7F5] hover:text-[#37352F]"}`}
    >
      {children}
    </Link>
  );
}
